export default __webpack_public_path__ + "static/media/NMAH-AC0433-0003439.30f1049a.jpeg";